const baseURL = {
  state: {
    baseURL: "https://www.jidcon.com/api/",
    // baseURL: 'http://192.168.0.148:3371/',
    downloadURL: "https://www.jidcon.com/download/",
    tyDownloadURL: "https://www.jbchip.com/download/",
    ossUrl: "https://www.jidcon.com/fd/",
  },
  getters: {},
};
export default baseURL;
